import { Record as record } from 'immutable';

import { construct, resolve } from '../../helpers/LinkMapper';
import Trip from '../order/Trip';
import { getOrderedPassengerTickets } from '../../utils/splits';

const defaults = {
    changeoverTicket: null,
    newTicket: null,
    changeover: false,
    changeoverTrip: null
};

class ChangeoverTicket extends record(defaults) {
    static fromJSON (json) {
        return construct(ChangeoverTicket, json, {
            changeoverTicket: json.changeoverTicket,
            newTicket: json.newTicket,
            changeover: json.changeover,
            changeoverTrip: resolve(json.changeoverTrip).as(Trip)
        });
    }

    isNewTicket (id) {
        return this.newTicket === id;
    }

    getOldFare () {
        return this.changeoverTrip.getFareByTicketId(this.changeoverTicket);
    }

    // Uses the same canonical ordering as the new/current side's passenger grouping
    // (getOrderedPassengerTickets, src/utils/splits.js) rather than raw array position, so old
    // and new tickets pair up by the same passenger convention on both sides of an amend.
    getPassengerIndex () {
        const fare = this.getOldFare();
        return fare ? getOrderedPassengerTickets(fare).findIndex(ticket => ticket.id === this.changeoverTicket) : -1;
    }
}

export default ChangeoverTicket;
